import React from 'react';
import { Row, Col, Select, Tag, Input } from 'antd';
import moment from 'moment';

const Option = Select.Option;
const { TextArea } = Input;

const HeaderVerAcuerdo = props => {
  const { acuerdo, usuario, hayDocsPendientes } = props;

  // Función auxiliar para renderizar cada fila de información
  const renderInfoRow = (label, content) => (
    <Row style={{ marginTop: 5 }} type="flex" justify="center">
      <Col span={11} offset={1}>
        <h3>{label}</h3>
      </Col>
      <Col span={11}>{content}</Col>
    </Row>
  );

  return (
    <>
      {renderInfoRow(
        'Fecha de Creación:',
        acuerdo.fechaCreacion
          ? moment(acuerdo.fechaCreacion).format('DD/MM/YYYY')
          : 'SIN DATOS'
      )}
      {renderInfoRow(
        'Organismo:',
        acuerdo.organismo ? acuerdo.organismo.nombre : 'SIN DATOS'
      )}
      {renderInfoRow(
        'Numero del Acuerdo:',
        acuerdo && acuerdo.numero ? <b>{acuerdo.numero}</b> : 'SIN DATOS'
      )}
      {renderInfoRow(
        'Cantidad de Documentos:',
        acuerdo.documentos ? acuerdo.documentos.length : 'SIN DATOS'
      )}
      {renderInfoRow(
        'Estado:',
        <Select
          size="default"
          disabled={
            !['SUPERVISOR', 'FUNCIONARIO'].includes(usuario.rol) ||
            acuerdo.estado === 'FINALIZADO' ||
            hayDocsPendientes ||
            acuerdo.numero === -1
          }
          placeholder="Seleccionar"
          defaultValue={acuerdo.estado ? acuerdo.estado : undefined}
          onChange={props.actualizarEstado}
          value={acuerdo.estado}
          style={{ width: '40%' }}
        >
          <Option value="EN TRAMITE">
            <Tag color="#108ee9">EN TRAMITE</Tag>
          </Option>
          <Option value="FINALIZADO">
            <Tag color="#f50">FINALIZADO</Tag>
          </Option>
        </Select>
      )}
      {acuerdo.estado === 'FINALIZADO' && (
        <>
          {renderInfoRow(
            'Acuerdo entre las partes:',
            <b>{acuerdo.hayAcuerdo ? 'SI' : 'NO'}</b>
          )}
          {renderInfoRow(
            'Fecha Finalizado:',
            acuerdo.fechaFinalizado
              ? moment(acuerdo.fechaFinalizado).format('DD/MM/YYYY')
              : 'SIN DATOS'
          )}
          {renderInfoRow(
            'Observaciones:',
            <TextArea
              rows={3}
              disabled
              value={
                acuerdo.observacionFinalizado
                  ? acuerdo.observacionFinalizado
                  : 'Sin observaciones'
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default HeaderVerAcuerdo;
